import { ICourseIn } from "../../models/input/trainingApi/ICourseIn";
import { ICourseUpdateIn } from "../../models/input/trainingApi/ICourseUpdateIn";
import { IEvaluationCourseIn } from "../../models/input/trainingApi/IEvaluationCourseIn";
import * as ApiWithToken from "../callApiWithToken";

const courseService = {
  getCoursesData: async function () {
    return ApiWithToken.postApi(
      process.env.REACT_APP_COURSES_API + `CourseControllers/GetCourseByUser`,
      null
    );
  },
  getCourseContent: async function (courseId: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_COURSES_API +
        `CourseControllers/GetCourseContent?courseId=${courseId}`
    );
  },
  getReinforcementCourseContent: async function (courseId: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_COURSES_API +
        `CourseControllers/GetReinforcementCourseContent?courseId=${courseId}`
    );
  },
  getEvaluationQuestion: async function (
    courseId: number,
    isReinforcement: boolean
  ) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_COURSES_API +
        `CourseControllers/GetCourseEvaluationQuestion?courseId=${courseId}&isReinforcement=${Number(isReinforcement)}`
    );
  },
  getEvaluationTimeRepeat: async function (courseId: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_COURSES_API +
        `CourseControllers/GetEvaluationRepeatTime?courseId=${courseId}`
    );
  },
  getCourseEvaluationResult: async function (answers: IEvaluationCourseIn) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_COURSES_API +
        `CourseControllers/CourseEvaluationResult`,
      answers
    );
  },
  getCourseReinforcementEvaluationResult: async function (
    answers: IEvaluationCourseIn
  ) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_COURSES_API +
        `CourseControllers/CourseReinforcementEvaluationResult`,
      answers
    );
  },
  getCourseCertificate: async function (courseId: number, languageId: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_COURSES_API +
        `CourseControllers/GetCourseCertificate?courseId=${courseId}&LaguadeId=${languageId}`
    );
  },
  getCourses: async function () {
    return ApiWithToken.getApi(
      process.env.REACT_APP_COURSES_API + `CourseControllers/GetCourses`
    );
  },
  postCourseImage: async function (imageFile: FormData) {
    return ApiWithToken.postImageApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/UploadActivationImage?Folder=CourseManagementCovers`,
      imageFile
    );
  },
  postCourseFile: async function (zipfile: FormData) {
    return ApiWithToken.postImageApi(
      process.env.REACT_APP_AGENDAS_API +
        `Activations/UploadActivationImage?Folder=CourseMaterials`,
      zipfile
    );
  },
  getCourseClasification: async function (languageId: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_COURSES_API +
        `CourseControllers/GetCourseClasification?languageId=${languageId}`
    );
  },
  getCourseCategories: async function (
    languageId: number,
    clasificationId: number
  ) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_COURSES_API +
        `CourseControllers/getCourseCategories?languageId=${languageId}&clasificationId=${clasificationId}`
    );
  },
  getCourseLanguages: async function (languageId: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_COURSES_API +
        `CourseControllers/GetCourseLanguages?languageId=${languageId}`
    );
  },
  getCourseCountries: async function (languageId: number) {
    return ApiWithToken.getApi(
      process.env.REACT_APP_COURSES_API +
        `CourseControllers/GetCourseCountries?languageId=${languageId}`
    );
  },
  postCourse: async function (courseIn: ICourseIn) {
    return ApiWithToken.postApi(
      process.env.REACT_APP_COURSES_API + `CourseControllers/CreateCourse`,
      courseIn
    );
  },
  updateCourse: async function (courseUpdateIn: ICourseUpdateIn) {
    return ApiWithToken.putApi(
      process.env.REACT_APP_COURSES_API + `CourseControllers/UpdateCourse`,
      courseUpdateIn
    );
  },
  updateCourseActive: async function (courseId: number, active: boolean) {
    return ApiWithToken.patchApi(
      process.env.REACT_APP_COURSES_API +
        `CourseControllers/UpdateCourseActive?courseID=${courseId}&active=${active}`,
      null
    );
  },
  deleteCourse: async function (courseId: number) {
    return ApiWithToken.deleteApi(
      process.env.REACT_APP_COURSES_API +
        `CourseControllers/DeleteCourse?courseID=${courseId}`
    );
  },
};
export default courseService;
